export default __webpack_public_path__ + "static/media/perfil.c793e0ac.png";